import { radioCardSlotRecipe as base } from '@chakra-ui/react/theme';

const baseVariants = base.variants as Record<string, Record<string, unknown>>;

export const radioCardSlotRecipe = {
  ...base,
  variants: {
    ...base.variants,
    variant: {
      ...baseVariants.variant,
      pill: {
        item: {
          flex: '0',
          borderRadius: 'full',
          borderWidth: '1px',
          borderColor: 'transparent',
          bg: 'whiteAlpha.50',
          color: 'whiteAlpha.700',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          transition: 'background 0.15s ease',
          _hover: { bg: 'whiteAlpha.100', color: 'white' },
          _checked: {
            bg: 'purple.500/20',
            color: 'purple.200',
            borderColor: 'purple.500/40',
            _hover: {
              bg: 'purple.500/30',
            },
          },
        },
        itemControl: {
          px: 3,
          py: 1.5,
          gap: 1.5,
        },
        itemIndicator: {
          display: 'none',
        },
        itemText: {
          fontSize: 'sm',
          fontWeight: '500',
        },
      },
    },
  },
};
